module.exports = __webpack_public_path__ + "img/king.17607985.png";